import {
  BATTERY_HISTORY_LOADING,
  BATTERY_HISTORY_ERROR,
  BATTERY_HISTORY_LIST,
  BATTERY_HISTORY_FILTERS
} from "actions/scooter/battery-history/constants";

const initialState = {
  loading: false,
  errors: [],

  filters: [],
  list: {
    content: []
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case BATTERY_HISTORY_LOADING:
      return {
        ...state,
        loading: action.payload.content
      };
    case BATTERY_HISTORY_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload.content
      };
    case BATTERY_HISTORY_FILTERS:
      return {
        ...state,
        errors: [],
        filters: action.payload.content,
      };
    case BATTERY_HISTORY_LIST:
      return {
        ...state,
        loading: false,
        errors: [],
        list: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/scooter/scooter/scooterBatteryHistoryReducer.js